import React from "react";
import { CommonDialog } from "../../../../components/common/CommonDialog";
import { DialogTitle, Stack } from "@mui/material";
import {
  FormButtonGroup,
  FormSelectInput,
  FormTextInput,
} from "../../../../components/form";
import { useSessionContext } from "../../../../contexts/SessionContext";
import { PatchPatient } from "../../../../services/fhir/patient/PatchPatient";
import { toast } from "react-toastify";

interface IProps {
  type: "add" | "edit";
  isOpen: boolean;
  handleClose: VoidFunction;
  display: any;
  control: any;
  handleSubmit: any;
}

export function SocialNameDialog({
  type,
  isOpen,
  handleClose,
  control,
  handleSubmit,
}: IProps) {
  const { userPatient, fetchUser } = useSessionContext();
  const auxSocialName = userPatient?.name?.find(
    (el: any) => el.use === "usual"
  );

  const auxSocialNameIndex = userPatient?.name?.findIndex(
    (el: any) => el.use === "usual"
  );

  function verifyPath() {
    if (auxSocialName === undefined) {
      return "/name/-";
    } else {
      return `/name/${auxSocialNameIndex}`;
    }
  }

  const onSubmit = async (data: any) => {
    const path = verifyPath();
    const content = {
      use: "usual",
      text: data.socialName,
    };

    try {
      await PatchPatient({
        patientId: userPatient?.id,
        operation: auxSocialNameIndex === -1 ? "add" : "replace",
        path,
        content,
      });
      await fetchUser();
      toast.success(
        `Nome social ${
          type === "add" ? "adicionado" : "atualizado"
        } com sucesso!`
      );
      handleClose();
    } catch (err) {
      console.log("err", err);
    }
  };

  return (
    <CommonDialog isOpen={isOpen} handleClose={handleClose}>
      <DialogTitle>
        {type === "add" ? "Adicionar" : "Atualizar"} Nome social
        <Stack marginY={2}>
          <FormTextInput
            name="socialName"
            label="Nome social"
            control={control}
            placeholder="Digite o nome social"
          />
        </Stack>
        <FormButtonGroup
          goBackButtonText="Cancelar"
          nextButtonText="Salvar"
          onGoBackButtonClick={handleClose}
          onNextButtonClick={handleSubmit(onSubmit)}
        />
      </DialogTitle>
    </CommonDialog>
  );
}
